import { Mail, Phone, ArrowUpRight } from "lucide-react";
import { Reveal, Eyebrow } from "./Reveal";
import { InquiryForm } from "./InquiryForm";

export const Contact = () => {
  return (
    <section id="contact" data-testid="contact-section" className="bg-[#F4F1EA] py-24 sm:py-32 lg:py-40 scroll-mt-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <Reveal>
              <Eyebrow>Start a Conversation</Eyebrow>
              <h2 className="mt-5 font-display text-4xl sm:text-5xl text-[#111513] leading-[1.12] text-balance">
                Let&rsquo;s understand <span className="italic text-[#A77A50]">the opportunity.</span>
              </h2>
              <p className="mt-6 text-lg text-[#5C665F] leading-relaxed">
                Whether you&rsquo;re thinking about selling or simply wondering what your property may be capable of,
                start here. You do not need to have anything figured out.
              </p>
            </Reveal>
            <Reveal delay={0.15}>
              <div className="mt-10 border-t-2 border-[#111513] pt-8">
                <p className="font-display text-2xl text-[#111513]">Choose Me Properties</p>
                <div className="mt-6 space-y-4">
                  <a
                    href="mailto:contact@choosemeproperties.com"
                    data-testid="contact-direct-email-link"
                    className="group flex items-center gap-3 text-base font-medium text-[#111513] hover:text-[#A77A50] transition-colors break-all"
                  >
                    <Mail className="w-5 h-5 text-[#A77A50] shrink-0" aria-hidden="true" />
                    contact@choosemeproperties.com
                  </a>
                  <a
                    href="tel:+12064831705"
                    data-testid="contact-direct-phone-link"
                    className="group flex items-center gap-3 text-base font-medium text-[#111513] hover:text-[#A77A50] transition-colors"
                  >
                    <Phone className="w-5 h-5 text-[#A77A50] shrink-0" aria-hidden="true" />
                    (206) 483-1705
                  </a>
                </div>
                <p className="mt-6 text-sm text-[#718477] leading-relaxed">
                  Ask for Jeremy Alfred, Taj Alfred, or Robert Swearengen III.
                </p>
                <a
                  href="tel:+12064831705"
                  data-testid="contact-call-button"
                  className="group mt-8 inline-flex items-center gap-2 text-[13px] font-semibold tracking-[0.12em] uppercase text-[#111513] border-b border-[#A77A50] pb-1 hover:text-[#A77A50] transition-colors"
                >
                  Call (206) 483-1705
                  <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" aria-hidden="true" />
                </a>
              </div>
            </Reveal>
          </div>
          <Reveal delay={0.1} className="lg:col-span-7">
            <InquiryForm />
          </Reveal>
        </div>
      </div>
    </section>
  );
};
